import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { client } from "@/main";
import PaginatedFetcher from "@/helpers/paginatedFetcher";
import { useProjectStore } from "@/store/modules/project";
export const useGroupsStore = defineStore("groups", () => {
    const groups = ref([]);
    const allGroups = ref([]);
    const groupsCount = ref(0);
    const groupsWithoutDevices = ref(0);
    const groupsWithoutEndpoints = ref(0);
    const groupsLoaded = ref(false);
    const loraDataFlowList = computed(() => groups.value.filter((g) => g.technology === "LORA"));
    async function getGroups() {
        const projectStore = useProjectStore();
        groupsLoaded.value = false;
        groupsWithoutDevices.value = 0;
        groupsWithoutEndpoints.value = 0;
        groups.value = [];
        const projectId = projectStore.selectedProject?.projectId;
        if (!projectId) {
            // No project selected → calling /projects/{id}/... with empty id
            // builds a malformed URL (/projects//device-groups/overview) and the
            // backend returns 500. Bail out cleanly instead.
            groupsLoaded.value = true;
            return true;
        }
        const response = await client.path("/projects/{id}/device-groups/overview").method("get").create()({
            id: projectId,
            shortlistSize: 30
        });
        const allGroupsData = await new PaginatedFetcher(client.path("/device-groups").method("get").create()).fetchAll({
            "projectId[eq]": projectId
        });
        const responseData = response.data.data ?? [];
        groupsCount.value = response.data.metadata?.count ?? 0;
        groups.value = responseData.map((df) => ({
            ...df,
            ...allGroupsData.find((group) => group.deviceGroupId === df.deviceGroupId)
        }));
        let withoutDevices = 0;
        let withoutEndpoints = 0;
        responseData.forEach((group) => {
            if (!group.devices)
                withoutDevices++;
            if (!group.endpoints)
                withoutEndpoints++;
        });
        groupsWithoutDevices.value = withoutDevices;
        groupsWithoutEndpoints.value = withoutEndpoints;
        groupsLoaded.value = true;
        return true;
    }
    async function getAllGroups() {
        const { data } = await client.path("/device-groups").method("get").create()({ limit: 9999 });
        allGroups.value = data.data ?? [];
    }
    async function getGroupsByIds(groupIds) {
        const { data } = await client.path("/device-groups").method("get").create()({
            limit: 9999,
            "deviceGroupId[in]": groupIds.join(",")
        });
        return data;
    }
    return {
        groups,
        allGroups,
        groupsCount,
        groupsWithoutDevices,
        groupsWithoutEndpoints,
        groupsLoaded,
        loraDataFlowList,
        getGroups,
        getAllGroups,
        getGroupsByIds
    };
});
